const testimonials = [
  {
    id: 1,
    name: "Michael Anderson",
    role: "CEO, Creative Studio",
    image: "https://placehold.co/120x120",
    review:
      "Working with Taikhoom was an incredible experience. Every detail was carefully executed, and the final results exceeded all expectations.",
  },
  {
    id: 2,
    name: "Sarah Wilson",
    role: "Marketing Director",
    image: "https://placehold.co/120x120",
    review:
      "Professional, creative, and always delivering on time. The photography and branding work significantly improved our online presence.",
  },
  {
    id: 3,
    name: "David Lee",
    role: "Entrepreneur",
    image: "https://placehold.co/120x120",
    review:
      "Excellent communication and outstanding quality. I would highly recommend working together on future creative projects.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="py-28 bg-gray-50 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6">

        <div className="relative text-center mb-20">

          <h2 className="absolute left-1/2 -translate-x-1/2 -top-10 text-[90px] lg:text-[160px] font-black uppercase text-gray-100 whitespace-nowrap">
            Testimonials
          </h2>

          <div className="relative">
            <span className="uppercase tracking-[6px] text-red-500 font-semibold">
              Clients Feedback
            </span>

            <h3 className="text-5xl font-black mt-5">
              What People Say
            </h3>
          </div>

        </div>

        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8">

          {testimonials.map((item) => (

            <div
              key={item.id}
              className="bg-white rounded-2xl p-8 shadow-lg hover:-translate-y-3 hover:shadow-2xl transition duration-300"
            >

              <div className="text-red-500 text-6xl font-black leading-none">
                "
              </div>

              <p className="text-gray-500 leading-8 mt-2 mb-8">
                {item.review}
              </p>

              <div className="flex items-center gap-4">

                <img
                  src={item.image}
                  alt={item.name}
                  className="w-16 h-16 rounded-full object-cover"
                />

                <div>

                  <h4 className="font-bold text-lg">
                    {item.name}
                  </h4>

                  <p className="text-gray-500 text-sm">
                    {item.role}
                  </p>

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>
    </section>
  );
}